import { render, staticRenderFns } from "./AdminViewInvoicePreview.vue?vue&type=template&id=4965012a&scoped=true"
import script from "./AdminViewInvoicePreview.vue?vue&type=script&lang=js"
export * from "./AdminViewInvoicePreview.vue?vue&type=script&lang=js"
import style0 from "./AdminViewInvoicePreview.vue?vue&type=style&index=0&id=4965012a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965012a",
  null
  
)

export default component.exports